import React, { useState, useEffect } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import AddCategoryForm from "./AddCategoryForm";
import CategoryRow from "./CategoryRow";
import ServicesRow from "./ServicesRow";
import {
  updateCategory,
  updateServiceItem,
  addCategoryToTentHouse,
  addItemsToCategory,
  uploadsapiid,
  uploadsmultipleimages_getids,
  deletetentcategory,
  deletetentservicewithid,
  
} from "../../../Apiservices/Auth/servers/fetchProviderData";
import { Upload } from "@mui/icons-material";
import ZipUploadButton from "./Zipuploadbutton";

const TenthouseserviceslistMUI = ({ tentservicelist = [] }) => {
  const [categories, setCategories] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [showAdd, setShowAdd] = useState(false);
  const [zipfileimages,setzipfileimages] = useState()
    // Change the initial state to handle both cases:
const [uploadedImages, setUploadedImages] = useState([]); // Start as array for new services

// But your service-specific uploads will convert it to object structure when needed
    const [serviceSearch, setServiceSearch] = useState("");

  useEffect(() => {
    if (tentservicelist.length > 0) {
      const mapped = tentservicelist.map(cat => ({
        id: cat.id,
        name: cat.cat_name || cat.name || "",
        description: cat.cat_description || cat.description || "",
        services: cat.services || []
      }));
      setCategories(mapped);
    }
  }, [tentservicelist]);

  const handleChange = (categoryId, field, value, serviceId = null) => {
    setEditData(prev => {
      const updated = { ...prev };
      if (!serviceId) {
        updated[categoryId] = { ...(updated[categoryId] || {}), [field]: value };
      } else {
        updated[categoryId] = {
          ...(updated[categoryId] || {}),
          services: {
            ...(updated[categoryId]?.services || {}),
            [serviceId]: {
              ...(updated[categoryId]?.services?.[serviceId] || {}),
              [field]: value
            }
          }
        };
      }
      return updated;
    });
  };

  const handleEdit = (categoryId) => {
    setEditRowId(categoryId);
    setExpandedRows(prev => ({ ...prev, [categoryId]: true }));

    const category = categories.find(c => c.id === categoryId);
    if (!category) return;

    const servicesObj = {};
    (category.services || []).forEach(s => {
      servicesObj[s.id] = { 
        service_name: s.service_name, 
        description: s.description,
        gallery: s.gallery || [] 
      };
    });

    setEditData(prev => ({
      ...prev,
      [categoryId]: {
        name: category.name,
        description: category.description,
        services: servicesObj
      }
    }));
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditData({});
  };
const handleSave = async (categoryId) => {
  console.log(`🟡 handleSave called for category ${categoryId}`);
  const data = editData[categoryId];
  if (!data) {
    console.log('❌ No edit data found for category', categoryId);
    return;
  }

  try {
    // --- 1️⃣ Update Category if changed ---
    const categoryPayload = {};
    if (data.name && data.name !== categories.find(c => c.id === categoryId)?.name) {
      categoryPayload.cat_name = data.name;
    }
    if (data.description && data.description !== categories.find(c => c.id === categoryId)?.description) {
      categoryPayload.cat_description = data.description;
    }

    if (Object.keys(categoryPayload).length > 0) {
      console.log(`🟡 Updating category ${categoryId}`);
      await updateCategory(categoryId, categoryPayload);
      setCategories(prev =>
        prev.map(c => c.id === categoryId ? { ...c, ...categoryPayload } : c)
      );
    }

    // --- 2️⃣ Update Services - Only those with changes ---
    if (data.services) {
      console.log(`🟡 Processing services for category ${categoryId}`);
      
      for (const [sid, sdata] of Object.entries(data.services)) {
        console.log(`🟡 Checking service ${sid} for changes`);
        
        const service = categories
          .find(c => c.id === categoryId)
          ?.services.find(s => s.id.toString() === sid.toString()); 

        if (!service) {
          console.log(`❌ Service ${sid} not found in category ${categoryId}`);
          continue;
        }

        const payload = {};

        // Check text field changes
        const hasNameChange = sdata.service_name && sdata.service_name !== service.service_name;
        const hasDescriptionChange = sdata.description && sdata.description !== service.description;
        
        if (hasNameChange) {
          payload.service_name = sdata.service_name;
        }
        if (hasDescriptionChange) {
          payload.description = sdata.description;
        }

        // --- Check image changes for this specific service ---
        const serviceUploadedImages = uploadedImages[sid] || [];
        const hasNewUploads = serviceUploadedImages.length > 0;
        
        const currentGallery = sdata.gallery || [];
        const currentImageIds = currentGallery.map(img => img.id);
        const existingImageIds = service.image_ids || [];
        const removedIds = existingImageIds.filter(id => !currentImageIds.includes(id));
        const hasRemovals = removedIds.length > 0;
        
        const hasImageChanges = hasNewUploads || hasRemovals;

        console.log(`🟡 Service ${sid} change analysis:`, {
          hasNameChange,
          hasDescriptionChange,
          hasNewUploads,
          hasRemovals,
          hasImageChanges,
          uploadedImagesCount: serviceUploadedImages.length,
          removedImagesCount: removedIds.length
        });

        if (hasImageChanges) {
          const newUploadedIds = serviceUploadedImages.map(img => img.id);
          const finalImageIds = [
            ...existingImageIds.filter(id => !removedIds.includes(id)),
            ...newUploadedIds
          ];

          payload.image_ids = finalImageIds;
          
          if (hasRemovals) {
            payload.image_mode = "replace";
            console.log(`🟡 Using replace mode for service ${sid}, removed ${removedIds.length} images`);
          }

          console.log(`🟡 Image changes detected for service ${sid}, updating image_ids`);
        }

        // Skip service if no changes at all
        if (Object.keys(payload).length === 0) {
          console.log(`⏩ Skipping service ${sid} - no changes detected`);
          continue;
        }

        console.log(`🚀 Calling updateServiceItem for service ${sid} with payload:`, payload);
        await updateServiceItem(sid, payload);
        console.log(`✅ updateServiceItem completed for service ${sid}`);
        
        // Update local state
        setCategories(prev =>
          prev.map(c =>
            c.id === categoryId
              ? {
                  ...c,
                  services: c.services.map(s =>
                    s.id.toString() === sid ? { 
                      ...s, 
                      ...payload,
                      // Only update image-related fields if they were changed
                      ...(hasImageChanges && { 
                        image_ids: payload.image_ids,
                        gallery: currentGallery 
                      })
                    } : s
                  ),
                }
              : c
          )
        );
      }
    }

    // --- 3️⃣ Cleanup - Only clear uploaded images for processed services ---
    setEditRowId(null);
    setEditData(prev => {
      const updated = { ...prev };
      delete updated[categoryId];
      return updated;
    });

    // Clear uploaded images only for services in this category that were processed
    setUploadedImages(prev => {
      const updated = { ...prev };
      // Remove only the service IDs that belong to this category
      Object.keys(data.services || {}).forEach(sid => {
        if (updated[sid]) {
          console.log(`🧹 Clearing uploaded images for service ${sid}`);
          delete updated[sid];
        }
      });
      return updated;
    });

    setRemovedImageIds([]);

    console.log(`✅ Saved category ${categoryId} successfully`);
  } catch (error) {
    console.error("❌ Error saving category/services:", error);
  }
};




  const handleDeletecategory = async (id) => {
  if (window.confirm("Are you sure you want to delete this category?")) {
    try {
      await deletetentcategory(id); // your API call
      setCategories((prev) => prev.filter((cat) => cat.id !== id));
      console.log("Category deleted:", id);
    } catch (err) {
      console.error("Error deleting category:", err);
    }
  }
};

const handleDeleteservice = async (serviceId, categoryId) => {
  if (window.confirm("Are you sure you want to delete this service?")) {
    try {
      // 🔹 Call your API to delete the service
      await deletetentservicewithid(serviceId);

      // 🔹 Update local state — remove the deleted service from its category
      setCategories((prev) =>
        prev.map((cat) =>
          cat.id === categoryId
            ? { ...cat, services: cat.services.filter((srv) => srv.id !== serviceId) }
            : cat
        )
      );

      console.log("✅ Service deleted:", serviceId);
    } catch (err) {
      console.error("❌ Error deleting service:", err);
    }
  }
};

  const [imageidfromuploads, setimageidfromuploads] = useState([])
  // ADDED: Store multiple image IDs
const handleServiceImageUpload = async (serviceId, files) => {
  try {
    const fileArray = Array.from(files);
    
    // Always use multiple upload endpoint, even for single files
    const previews = fileArray.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
    }));

    const responseData = await uploadsmultipleimages_getids(fileArray);

    if (responseData?.files?.length) {
      const uploaded = responseData.files.map((fileData, index) => ({
        id: fileData.id,
        fileName: fileData.file_name,
        previewUrl: previews[index].previewUrl,
      }));

      if (serviceId) {
        // For existing services - store per service
        setUploadedImages(prev => ({
          ...prev,
          [serviceId]: [...(prev[serviceId] || []), ...uploaded]
        }));
      } else {
        // For new services - add to global array
        setUploadedImages(prev => [...prev, ...uploaded]);
      }

      return { success: true, images: uploaded, data: responseData };
    }

    return { success: false, error: "No file IDs received" };
  } catch (error) {
    console.error("Error uploading service images:", error);
    return { success: false, error: error.message };
  }
};



const removeServiceImage = async (serviceId, imageId) => {
  console.log(`🟡 Removing image ${imageId} from service ${serviceId}`);
  
  if (serviceId) {
    // Update UI immediately - remove from editData gallery
    setEditData(prev => {
      const updated = { ...prev };
      Object.keys(updated).forEach(catId => {
        if (updated[catId]?.services?.[serviceId]?.gallery) {
          updated[catId].services[serviceId].gallery = 
            updated[catId].services[serviceId].gallery.filter(img => img.id !== imageId);
          console.log(`🟡 Removed image from editData gallery for service ${serviceId}`);
        }
      });
      return updated;
    });

    // Clean up uploadedImages if needed (for newly uploaded images)
    setUploadedImages(prev => {
      if (typeof prev === 'object' && !Array.isArray(prev) && prev[serviceId]) {
        const updated = { ...prev };
        const removedImage = updated[serviceId].find(img => img.id === imageId);
        if (removedImage?.previewUrl) {
          URL.revokeObjectURL(removedImage.previewUrl);
        }
        updated[serviceId] = updated[serviceId].filter(img => img.id !== imageId);
        if (updated[serviceId].length === 0) delete updated[serviceId];
        console.log(`🟡 Removed image from uploadedImages for service ${serviceId}`);
        return updated;
      }
      return prev;
    });

    // 🔥 Direct API call for image removal
    try {
      const serviceIdStr = serviceId.toString();
      
      // Find the category that contains this service
      let foundCategory = null;
      for (const cat of categories) {
        if (cat.services.some(s => s.id.toString() === serviceIdStr)) {
          foundCategory = cat;
          break;
        }
      }

      if (foundCategory) {
        // Get the current gallery state from editData (includes all images user sees)
        const currentGallery = editData[foundCategory.id]?.services?.[serviceId]?.gallery || [];
        const currentImageIds = currentGallery.map(img => img.id);
        
        // Get the original service to distinguish between existing and new images
        const originalService = categories
          .find(cat => cat.id === foundCategory.id)
          ?.services.find(s => s.id.toString() === serviceIdStr);

        const originalImageIds = originalService?.image_ids || [];
        
        // Separate newly uploaded images from existing backend images
        const newlyUploadedImages = Array.isArray(uploadedImages) 
          ? uploadedImages 
          : uploadedImages[serviceId] || [];
        const newUploadedIds = newlyUploadedImages.map(img => img.id);
        
        // Calculate which images to keep (all current except the removed one)
        const finalImageIds = currentImageIds.filter(id => id !== imageId);
        
        // Determine if the removed image was from backend or newly uploaded
        const wasBackendImage = originalImageIds.includes(imageId);
        const wasNewImage = newUploadedIds.includes(imageId);
        
        console.log(`🟡 Image removal analysis:`, {
          originalImageIds,
          newUploadedIds,
          currentImageIds,
          finalImageIds,
          removedImageId: imageId,
          wasBackendImage,
          wasNewImage
        });

        // Only call API if we're removing a backend image or if there are actual changes
        if (wasBackendImage || finalImageIds.length !== originalImageIds.length) {
          const payload = {
            image_ids: finalImageIds,
            image_mode: "replace"
          };

          console.log(`🚀 Direct API call for image removal:`, payload);
          await updateServiceItem(serviceId, payload);
          console.log(`✅ Image removed via API`);

          // Update local state to reflect backend changes
          setCategories(prev =>
            prev.map(cat =>
              cat.id === foundCategory.id
                ? {
                    ...cat,
                    services: cat.services.map(s =>
                      s.id.toString() === serviceIdStr
                        ? { 
                            ...s, 
                            image_ids: finalImageIds,
                            // Also update gallery to match the current state
                            gallery: currentGallery.filter(img => img.id !== imageId)
                          }
                        : s
                    )
                  }
                : cat
            )
          );
        } else {
          console.log(`⏩ Skipping API call - only new image removed, no backend changes needed`);
        }
      } else {
        console.log(`❌ Could not find category for service ${serviceId}`);
      }
    } catch (error) {
      console.error("❌ Error in direct image removal API call:", error);
    }
    
  } else {
    // Remove from new service (no API call needed)
    setUploadedImages(prev => {
      if (Array.isArray(prev)) {
        const imageToRemove = prev.find(img => img.id === imageId);
        if (imageToRemove?.previewUrl) URL.revokeObjectURL(imageToRemove.previewUrl);
        console.log(`🟡 Removed image from new service uploadedImages`);
        return prev.filter(img => img.id !== imageId);
      }
      return prev;
    });
  }
};


// ADDED: Handle image upload and store IDs
const handleMultipleUploads = async (files) => {
  try {
    // convert FileList to array
    const fileArray = Array.from(files);

    // create local preview URLs first
    const previews = fileArray.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
    }));

    // upload all files to API
    const responseData = await uploadsmultipleimages_getids(fileArray);

    // expect: responseData.files = [{ id, file_name, ... }]
    if (responseData?.files?.length) {
      const uploaded = responseData.files.map((fileData, index) => ({
        id: fileData.id,
        fileName: fileData.file_name,
        previewUrl: previews[index].previewUrl, // local preview
      }));

      // update state
      setUploadedImages((prev) => [...prev, ...uploaded]);

      return { success: true, images: uploaded, data: responseData };
    }

    return { success: false, error: "No file IDs received" };
  } catch (error) {
    console.error("Error uploading multiple images:", error);
    return { success: false, error: error.message };
  }
};

  const handleUploadImageApi = async (file,description='') => {
    try {
       console.log("📤 [IMAGE UPLOAD] Starting image upload");
  console.log("📁 File details:", {
    name: file?.name,
    type: file?.type,
    size: file?.size,
    description: description
  });
          console.log("🔗 [IMAGE UPLOAD] Creating preview URL...");
    const previewUrl = URL.createObjectURL(file);
    
    console.log("📤 [IMAGE UPLOAD] Calling uploadsapiid with file and description...");
    const response = await uploadsapiid(file, description);
      
      if (response?.data?.file?.id) {
        const newImage = {
          id: response.data.file.id,
          previewUrl: previewUrl,
          fileName: response.data.file.file_name
        };
        // setUploadedImages(prev => [...prev, newImage]);
        return { success: true, image: newImage, data: response.data };
      }
      return { success: false, error: "No image ID received" };
    } catch (error) {
      console.error("Error uploading image:", error);
      return { success: false, error: error.message };
    }
  };


// ADDED: Remove image ID from the list
const [removedImageIds, setRemovedImageIds] = useState([]);

const removeUploadedImage = (imageId) => {
  setUploadedImages(prev => {
    const imageToRemove = prev.find(img => img.id === imageId);
    if (imageToRemove?.previewUrl) {
      URL.revokeObjectURL(imageToRemove.previewUrl); // cleanup
    }
    return prev.filter(img => img.id !== imageId);
  });

  // Add to removed list
  setRemovedImageIds(prev => [...prev, imageId]);
};

// 

  // Handle adding new service to existing category
// Fix handleAddService to use the correct uploadedImages structure:
const handleAddService = async (categoryId, newService) => {
  try {
    // Get image IDs from the global uploadedImages array (for new services)
    const imageIds = Array.isArray(uploadedImages) 
      ? uploadedImages.map(img => img.id) 
      : [];

    const itemsPayload = [{
      service_name: newService.service_name,
      description: newService.description,
      image_ids: imageIds
    }];

    const response = await addItemsToCategory(categoryId, itemsPayload);
    console.log("response", response);
    
    if (response.success) {
      const serviceToAdd = {
        id: response.data[0]?.id,
        service_name: newService.service_name,
        description: newService.description,
        image_ids: imageIds,
        gallery: Array.isArray(uploadedImages) ? uploadedImages : []
      };

      // Update local state
      setCategories(prev =>
        prev.map(cat =>
          cat.id === categoryId
            ? {
                ...cat,
                services: [...cat.services, serviceToAdd]
              }
            : cat
        )
      );

      // Clear uploaded images after successful service creation
      setUploadedImages([]);
      
      console.log("Service added successfully:", serviceToAdd);
    } else {
      console.error("Failed to add service:", response.message);
    }
  } catch (error) {
    console.error("Error adding service:", error);
  }
};

  // Handle adding new category
const handleAddCategory = async (newCategory) => {
  try {
    // Check if category already exists
    const existingCategory = categories.find(
      (c) => c.name === newCategory.name
    );

    if (existingCategory) {
      // Add services to existing category
      if (newCategory.services.length > 0) {
        const itemsPayload = newCategory.services.map(service => ({
          service_name: service.service_name,
          description: service.description,
          image_ids: service.image_ids || [] // Use the already uploaded image IDs
        }));

        const addItemsResponse = await addItemsToCategory(
          existingCategory.id,
          itemsPayload
        );

        console.log("Added services:", addItemsResponse.data);

        setCategories((prev) =>
          prev.map((c) =>
            c.id === existingCategory.id
              ? {
                  ...c,
                  services: [...c.services, ...addItemsResponse.data],
                }
              : c
          )
        );
      }
    } else {
      // Add new category + optional services
      const payload = {
        cat_name: newCategory.name,
        cat_description: newCategory.description,
        items: newCategory.services.map(service => ({
          service_name: service.service_name,
          description: service.description,
          image_ids: service.image_ids || [] // Use the already uploaded image IDs
        })),
      };

      const response = await addCategoryToTentHouse(payload);

      if (response.success) {
        console.log("Category added:", response.data);
        const newCategoryData = {
          id: response.data.id,
          name: response.data.cat_name,
          description: response.data.cat_description,
          services: response.data.services || []
        };
        setCategories((prev) => [...prev, newCategoryData]);
      } else {
        console.error("Failed to add category:", response.message);
      }
    }

    setShowAdd(false);
  } catch (error) {
    console.error("Error in handleAddCategory:", error);
  }
};

  const toggleExpand = (categoryId) => {
    setExpandedRows(prev => ({ ...prev, [categoryId]: !prev[categoryId] }));
  };
const filteredCategories = categories
  .map((category) => {
    const filteredServices = category.services.filter(
      (s) =>
        s.service_name?.toLowerCase().includes(serviceSearch.toLowerCase()) ||
        s.description?.toLowerCase().includes(serviceSearch.toLowerCase())
    );

    return { ...category, services: filteredServices };
  })
  .filter((cat) =>
    serviceSearch.trim() === "" ? true : cat.services.length > 0
  );
useEffect(() => {
  if (serviceSearch.trim() !== "") {
    const expandedMap = {};
    filteredCategories.forEach((cat) => {
      if (cat.services.length > 0) expandedMap[cat.id] = true;
    });
    setExpandedRows(expandedMap);
  }
}, [serviceSearch, categories]);

  return (
    <Box>
      <Button variant="contained"  
        sx={{
          backgroundColor: 'black',
          color: 'white',
          '&:hover': {
            backgroundColor: '#333',
          },
        }} 
        onClick={() => setShowAdd(true)}
      >
        Add Category
      </Button>
        
            {/* ZIP Upload Button */}
           <ZipUploadButton />
      {showAdd && (
        <AddCategoryForm 
          onAddCategory={handleAddCategory} 
          onCancel={() => setShowAdd(false)}
          onUploadImage={handleUploadImageApi}
        />
      )}
      <Box sx={{ mt: 2, mb: 2 }}>
  <input
    type="text"
    placeholder="Search services..."
    value={serviceSearch}
    onChange={(e) => setServiceSearch(e.target.value)}
    style={{
      padding: "8px 12px",
      width: "300px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "14px",
    }}
  />
</Box>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Category Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
   <TableBody>

  {filteredCategories.map((category) => (
    <React.Fragment key={category.id}>
      <CategoryRow
        key={category.id}
        category={category}
        editRowId={editRowId}
        editData={editData}
        handleChange={handleChange}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleDelete={handleDeletecategory}
        expanded={expandedRows[category.id]}
        toggleExpand={toggleExpand}
      />

      {expandedRows[category.id] && (
         <ServicesRow
    category={category}
    editRowId={editRowId}
    editData={editData}
    onAddService={handleAddService}
    onUploadImage={handleUploadImageApi} 
    uploadedImages={uploadedImages}
    onRemoveImageId={removeServiceImage} // Use service-specific removal
    handleDeleteservice={handleDeleteservice}
    setEditData={setEditData}
    setUploadedImages={setUploadedImages}
  />
      )}
    </React.Fragment>
  ))}
</TableBody>

        </Table>
      </TableContainer>
    </Box>
  );
};

export default TenthouseserviceslistMUI;